export default {
    add_playlist: "Añadir a la playlist",
    audio_save_error: "Se produjo un error al guardar el audio",
    audio_save_success: "Audio guardado con éxito",
    audios: "Audios",
    delete_playlist: "Remover Playlist",
    duration: "Duración",
    episode: "Episodio",
    episode_plural: "Episodios",
    favorite_podcast: "Podcast Favorito",
    how_do_you_rate_this_podcast: "¿Cómo valora este podcast?",
    like_podcast: "Curtir Podcast",
    listened: "Oído",
    listening: "Escuchando",
    loading_podcasts: "Cargando podcasts",
    new_playlist: "Nueva playlist",
    new_podcast: "Nuevo podcast",
    no_audios_on_podcast: "Sin audio en el podcast",
    no_podcasts_are_available_at_the_moment: "Actualmente no hay podcasts disponibles",
    no_podcasts_are_available_with_the_selected_filter: "No hay podcasts disponibles para el filtro seleccionado",
    no_podcasts_found: "No se encontró ningún podcast",
    no_podcasts_found_with_this_filter: "No se encontró ningún podcast con este filtro.",
    only_available_when_finished_podcast: "Disponible solo después de completar el podcast",
    play_sound: "Tocar",
    playlist: "Playlist",
    playlist_save_success: "Lista de reproducción grabada con éxito",
    playlists: "Playlists",
    podcast: "Podcast",
    podcast_report: "Informe de podcast",
    podcasts: "Podcasts",
    there_are_no_podcasts_avaliable_at_the_moment: "No hay ningún podcast disponible em enste momento",
    to_listen: "Para escuchar",
    unexpected_error_try_again_later: "Error inesperado intente nuevamente más tarde",
    unfavorite_podcast: "Podcast Desfavorito",
    unlike_podcast: "Descurtir Podcast"
}
